
import {Vue, Component, Watch} from 'vue-property-decorator';
import {BTable, BDropdown} from "bootstrap-vue";
import store from "@/services/store";
import { loadUserLevels } from "../budget/budgetVariantService";
import {CorrectRowClass} from "@/modules/budget/budget-correct/CorectHelper";
import ReportModal from './InputReportModal.vue';
import DatePicker from 'vue2-datepicker';
import UrlModal from './UrlModal.vue';
import CommentModal from './CommentModal.vue';
import ExcelExport from './ExcelExport.vue'
import axios from "axios";
import VueElementLoading from "vue-element-loading";
import * as XLSX from 'xlsx';

interface TableItem {
    id: number;
    report_number: string;
    project: string;
    report_date: string;
    object_place: string;
    customer_bin: string;
    customer: string;
    planner_bin: string;
    planner: string;
    finance_source: string;
    timelimit: string;
    status: string;
    comment: string;
    url: string;
    object_category: string;
    input_report: string;
    contract_number: string;
    project_code: string;
    contract_amount: null;
    amount_plan: null;
}

@Component({
    components: {
        loading: VueElementLoading,
        UrlModal,
        CommentModal,
        ReportModal,
        ExcelExport,
        DatePicker
    },
})

export default class psd_form extends Vue {
    async mounted() {
        await this.getUserLevels();
        await this.load_psd();  // Загружаем данные
        await this.loadFilterOptions();
        await this.getObl();
        await this.getCodeList();
        // this.initializeFilters(); // Заполняем фильтры
    }

    $refs!: {
        urlModal: UrlModal;
        drop: BDropdown;
        reportModal: ReportModal;
        excelExport: ExcelExport;
        table: BTable;
    };

    filterObjectName: { project: string } | null = null;
    filterProjectTime: { timelimit: string } | null = null;
    filterObjectPlace: { object_place: string } | null = null;
    filterCustomerBIN: { customer: string } | null = null;
    filterPlanner: { planner: string } | null = null;
    filterFinanceSource: { value: string } | null = null;
    filterStatus: { value: string; text: string } | null = null;
    filterCategory: { value: string; text: string } | null = null;
    filterStartDate: string | null = null;
    filterEndDate: string | null = null;
    dateFromForInput: Date | null = null; // Дата начала
    dateToForInput: Date | null = null; // Дата окончания

    fields = [
        {key: 'report_number', label: 'Номер заключения', sortable: true},
        {key: 'project', label: 'Наименование проекта', sortable: true},
        {key: 'report_date', label: 'Дата заключения', sortable: true},
        {key: 'object_place', label: 'Место расположения объекта', sortable: true},
        {key: 'customer', label: 'Заказчик', sortable: true},
        {key: 'planner', label: 'Проектировщик', sortable: true},
        {key: 'project_code', label: 'Код проекта', sortable: false},
        {key: 'timelimit', label: 'Срок', sortable: true},
        {key: 'status', label: 'Статус', sortable: false},
        {key: 'comment', label: 'Комментарии', sortable: false},
        {key: 'url', label: 'URL', sortable: false},
        {key: 'object_category', label: 'Категория объекта', sortable: false},
        {key: 'input_report', label: 'Акт ввода', sortable: false},
        {key: 'contract_number', label: '№ договора', sortable: true},
        {key: 'contract_amount', label: 'Сумма по договору', sortable: true},
        {key: 'amount_plan', label: 'Сумма по плану', sortable: true}
    ]

    filteredItems: TableItem[] = [];
    items: TableItem[] = []

    modalVisible: boolean = false

    setText(key: string): string {
        const translations: Record<string, string> = {
            filter: "Фильтр",
            filter_params: "Параметры фильтра",
            DateOf: "Дата заключения",
            period_from: "с",
            period_to: "по",
            apply: "ПРИМЕНИТЬ",
            reset: "СБРОСИТЬ",
            report_title: "Проектно-сметная документация"
        };
        return translations[key] || key;
    }

    async loadFilterOptions() {
        try {
            const params = new URLSearchParams();

            // Пока грузится — показать "Загрузка..."
            this.filterObjectOptions = [{ project: 'Загрузка...', disabled: true }];
            this.filterProjectTimeOptions = [{ timelimit: 'Загрузка...', disabled: true }];
            this.filterObjectPlaceOptions = [{ object_place: 'Загрузка...', disabled: true }];
            this.filterCustomerOptions = [{ customer: 'Загрузка...', disabled: true }];
            this.filterPlannerOptions = [{ planner: 'Загрузка...', disabled: true }];
            this.filterCategoryOptions = [{ value: 'loading', text: 'Загрузка...', disabled: true }];
            this.filterStatusOptions = [{ value: 'loading', text: 'Загрузка...', disabled: true }];


            if (this.filterObjectName) params.append("project", this.filterObjectName.project);
            if (this.filterProjectTime) params.append("timelimit", this.filterProjectTime.timelimit);
            if (this.filterObjectPlace) params.append("object_place", this.filterObjectPlace.object_place);
            if (this.filterCustomerBIN) params.append("customer", this.filterCustomerBIN.customer);
            if (this.filterPlanner) params.append("planner", this.filterPlanner.planner);
            if (this.filterCategory) params.append("object_category", this.filterCategory.value);
            if (this.filterStatus) params.append("status", this.filterStatus.value);
            if (this.dateFromForInput) {
                params.append("date_from", this.dateFromForInput.toISOString().slice(0, 10));
            }
            if (this.dateToForInput) {
                params.append("date_to", this.dateToForInput.toISOString().slice(0, 10));
            }

            const response = await fetch(`/api-py/psd/filters?${params.toString()}`);
            const data = await response.json();

            this.filterObjectOptions = (data.projects as string[]).map((p: string) => ({ project: p }));
            this.filterProjectTimeOptions = (data.timelimits as string[]).map((t: string) => ({ timelimit: t }));
            this.filterObjectPlaceOptions = (data.object_places as string[]).map((o: string) => ({ object_place: o }));
            this.filterCustomerOptions = (data.customers as string[]).map((c: string) => ({ customer: c }));
            this.filterPlannerOptions = (data.planners as string[]).map((p: string) => ({ planner: p }));
            this.filterCategoryOptions = this.formatToValueText(data.categories as string[]);
            this.filterStatusOptions = this.formatToValueText(data.statuses as string[]);

            // 🔄 Проверка и сброс невалидных фильтров
            const validateSelection = (
                current: Record<string, any> | null,
                list: Record<string, any>[],
                key: string
            ): boolean => {
                return !!current && list.some((opt: Record<string, any>) => opt[key] === current[key]);
            };

            if (!validateSelection(this.filterObjectName, this.filterObjectOptions, 'project')) {
                this.filterObjectName = null;
            }
            if (!validateSelection(this.filterProjectTime, this.filterProjectTimeOptions, 'timelimit')) {
                this.filterProjectTime = null;
            }
            if (!validateSelection(this.filterObjectPlace, this.filterObjectPlaceOptions, 'object_place')) {
                this.filterObjectPlace = null;
            }
            if (!validateSelection(this.filterCustomerBIN, this.filterCustomerOptions, 'customer')) {
                this.filterCustomerBIN = null;
            }
            if (!validateSelection(this.filterPlanner, this.filterPlannerOptions, 'planner')) {
                this.filterPlanner = null;
            }
            if (!validateSelection(this.filterCategory, this.filterCategoryOptions, 'value')) {
                this.filterCategory = null;
            }
            if (!validateSelection(this.filterStatus, this.filterStatusOptions, 'value')) {
                this.filterStatus = null;
            }
        } catch (e) {
            this.makeToast("danger", "Ошибка загрузки фильтров", String(e));
        }
    }


    applyFilter() {
        this.page = 1;
        this.load_psd().then(() => this.loadFilterOptions());
    }

    async resetFilter() {
        this.filterObjectName = null;
        this.filterProjectTime = null;
        this.filterObjectPlace = null;
        this.filterCustomerBIN = null;
        this.filterPlanner = null;
        this.filterFinanceSource = null;
        this.filterCategory = null;
        this.filterStatus = null;
        this.dateFromForInput = null;
        this.dateToForInput = null;
        this.page = 1;

        await this.load_psd();
        await this.loadFilterOptions(); 
    }

    private cachedFilters: Record<string, any[]> = {};

    getUniqueValues(array: any[], key: string): any[] {
        // Ключ для кэша должен включать длину массива, чтобы обновлялось при изменении данных
        const cacheKey = `${key}_${array.length}`;
        if (this.cachedFilters[cacheKey]) return this.cachedFilters[cacheKey];

        // Добавляем "Null" только для timelimit
        const options = key === 'timelimit' ? [{ [key]: null, label: 'Null' }, ...array] : [...array];

        const result = Array.from(new Map(options.map(item => [item[key], item])).values())
            .sort((a, b) => {
                if (a[key] === null) return -1;
                if (b[key] === null) return 1;

                const aVal = typeof a[key] === 'number' ? a[key] : parseFloat(a[key]);
                const bVal = typeof b[key] === 'number' ? b[key] : parseFloat(b[key]);

                if (!isNaN(aVal) && !isNaN(bVal)) {
                    return aVal - bVal;
                }

                return String(a[key]).localeCompare(String(b[key]));
            });

        this.cachedFilters[cacheKey] = result;
        return result;
    }

    private hide() {
        (this.$refs.drop as BDropdown).hide(true)
    }

    page: number = 1;
    limit: number = 10;
    total: number = 0;

    async load_psd() {
        try {
            const params = new URLSearchParams();

            params.append("page", this.page.toString());
            params.append("limit", this.limit.toString());

            if (this.filterObjectName) params.append("project", this.filterObjectName.project);
            if (this.filterProjectTime) params.append("timelimit", this.filterProjectTime.timelimit);
            if (this.filterObjectPlace) params.append("object_place", this.filterObjectPlace.object_place);
            if (this.filterCustomerBIN) params.append("customer", this.filterCustomerBIN.customer);
            if (this.filterPlanner) params.append("planner", this.filterPlanner.planner);
            if (this.filterCategory) params.append("object_category", this.filterCategory.value);
            if (this.filterStatus) params.append("status", this.filterStatus.value);
            if (this.dateFromForInput) {
                const fromDate = this.dateFromForInput.toISOString().slice(0, 10);
                params.append("date_from", fromDate);
            }
            if (this.dateToForInput) {
                const toDate = this.dateToForInput.toISOString().slice(0, 10);
                params.append("date_to", toDate);
            }

            const response = await fetch(`/api-py/psd/all?${params.toString()}`);
            if (!response.ok) throw new Error("Ошибка запроса");

            const result = await response.json();
            this.items = result.items;
            this.filteredItems = [...this.items]; // Просто копия, не фильтруется вручную
            this.total = result.total;
        } catch (e) {
            this.makeToast("danger", "Ошибка загрузки данных", String(e));
        }
    }




    closeModal() {
        this.$emit('close');
    }

    exitWithoutSaving() {
        this.$emit('exit');
        this.closeModal();
    }

    saveAndExit() {
        this.$emit('save');
        this.closeModal();
    }

    selectedItem: any = null;

    onClickReport(item: any) {
        this.selectedItem = item; 
        console.log('selected', this.selectedItem);
        this.$bvModal.show("add_input_report_modal"); 
    }

    addReport(input_report: string) {
        if (this.selectedItem) {
            this.$set(this.selectedItem, "input_report", input_report);
            this.updateEditedItem(this.selectedItem);
        }
    }


    onClickUrl(item: any) {
        this.selectedItem = item;
        console.log('selected', this.selectedItem)
        this.$bvModal.show("add_url_modal")
    }

    addUrl(url: any) {
        this.$set(this.selectedItem, "url", url)
        this.updateEditedItem(this.selectedItem);
    }

    onClickComment(item: any) {
        this.selectedItem = item;
        console.log('selected', this.selectedItem)
        this.$bvModal.show("add_comment_modal")
    }

    addComment(comment: any) {
        this.$set(this.selectedItem, "comment", comment)
        this.updateEditedItem(this.selectedItem);
    }

    private makeToast(variant: any, title: string, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }

    truncateComment(comment: any) {
        return comment.length > 15 ? comment.slice(0, 15) + '...' : comment;
    }

    showModal = false;
    editedItem: TableItem = {} as TableItem;
    statusOptions = [
        {value: 'реализован', text: 'Реализован'},
        {value: 'активный', text: 'Активный'},
        {value: 'не реализован', text: 'Не реализован'},
        {value: 'требуется финансирование', text: 'Требуется финансирование'}
    ];

    categoryOptions = [
        {value: 'жилой', text: 'Жилой'},
        {value: 'коммерческий', text: 'Коммерческий'},
        {value: 'общественный', text: 'Общественный'},
        {value: 'инфраструктура', text: 'Инфраструктура'}
    ];

    financeOptions = [
        {value: 'государственный', text: 'Государственный'},
        {value: 'квазигосударственный', text: 'Квазигосударственный'},
        {value: 'частный', text: 'Частный'}
    ];

    originalItems = [];

    async fetchData() {
        try {
            const response = await fetch('/api-py/psd/all');
            if (response.status === 200) {
                const result = await response.json();
                this.items = JSON.parse(JSON.stringify(result));
                this.originalItems = JSON.parse(JSON.stringify(result));
            }
        } catch (error) {
            console.error("Ошибка загрузки данных:", error);
        }
    }

    clickEditRow(item: TableItem) {
        console.debug(item)
    }

    editRow(item: TableItem) {
        this.editedItem = {...item}; // Создаём копию объекта, чтобы избежать привязки
        this.showModal = true;
    }

    updateEditedItem(item: TableItem) {
        this.editedItem = {...item}; // Обновляем editedItem перед сохранением
    }

    saveChanges() {
        this.items = this.items.map(item => {
            if (item.report_number === this.editedItem.report_number) {
                return {...this.editedItem}; // Обновляем объект в массиве
            }
            return item;
        });

        this.saveToDb(this.editedItem); // Отправляем обновленные данные в базу
    }

    async saveToDb(item: TableItem) {
        console.log(item)
        try {
            const result = await fetch("/api-py/psd/update/", {
                method: 'PUT',
                body: JSON.stringify(item)
            })
            if (result.status === 200) {
                const response = await result.json();
                this.makeToast("success", "Результат сохранения", response["message"]);
            } else {
                this.makeToast('info', 'save-correct-data', "Изменений не было");
                return;
            }
        } catch (error) {
            this.makeToast('danger', 'Ошибка запроса save-correct-data', (error as Error).toString());
            return;
        }
    }

    onlyNumbersFor(event: KeyboardEvent) {
        const allowedKeys = [
            'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', '.'
        ];

        // Разрешаем цифры, запятые, точки и несколько других клавиш
        const isDigit = /^\d$/.test(event.key);

        if (!isDigit && !allowedKeys.includes(event.key)) {
            event.preventDefault();
        }
    }

    handleAmountChange(item: any, field: 'contract_amount' | 'amount_plan') {
        const value = item[field];
        if (value === null || value === '' || isNaN(value)) {
            item[field] = null;
        } else {
            item[field] = parseFloat(parseFloat(value).toFixed(1));
        }
        this.updateEditedItem(item);
    }


    @Watch('dateFromForInput')
    onDateFromChange(newVal: Date | null) {
        if (newVal && this.dateToForInput && newVal > this.dateToForInput) {
            this.dateToForInput = newVal;
        }
    }

    @Watch('dateToForInput')
    onDateToChange(newVal: Date | null) {
        if (newVal && this.dateFromForInput && newVal < this.dateFromForInput) {
            this.dateFromForInput = newVal;
        }
    }

    getContractNumberProxy(item: TableItem): string {
        const onlyDigits = item.contract_number?.match(/\d+/g);
        return onlyDigits ? onlyDigits.join('') : item.contract_number || '';
    }

    onContractNumberInput(value: string, item: TableItem) {
        item.contract_number = value;
        this.updateEditedItem(item);
    }

    onlyNumbers(event: any) {
        // Allow only digits (0-9), backspace, delete, and arrow keys
        if (!/^\d$/.test(event.key) && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
            event.preventDefault();
        }
    }

    onlyAllowedContractChars(event: KeyboardEvent) {
        const allowedPattern = /^[a-zA-Zа-яА-Я0-9\-\/]$/;
        if (!allowedPattern.test(event.key)) {
            event.preventDefault();
        }
    }

    sanitizeInput(row: any) {
        // Ensure the value contains only numbers and is within the limit
        let value = row.item.timelimit.toString().replace(/\D/g, ''); // Remove non-numeric characters
        value = Math.min(Math.max(parseInt(value, 10) || 1, 1), 999); // Keep it within the range
        row.item.timelimit = value;
    }

    noMoreThree(value: any) {
        return String(value).substring(0, 3);
    }

    async downloadPsdExcel() {
        try {
            const params = new URLSearchParams();

            if (this.filterObjectName) params.append("project", this.filterObjectName.project);
            if (this.filterProjectTime) params.append("timelimit", this.filterProjectTime.timelimit);
            if (this.filterObjectPlace) params.append("object_place", this.filterObjectPlace.object_place);
            if (this.filterCustomerBIN) params.append("customer", this.filterCustomerBIN.customer);
            if (this.filterPlanner) params.append("planner", this.filterPlanner.planner);
            if (this.filterCategory) params.append("object_category", this.filterCategory.value);
            if (this.filterStatus) params.append("status", this.filterStatus.value);
            if (this.dateFromForInput) {
                const fromDate = this.dateFromForInput.toISOString().slice(0, 10);
                params.append("date_from", fromDate);
            }
            if (this.dateToForInput) {
                const toDate = this.dateToForInput.toISOString().slice(0, 10);
                params.append("date_to", toDate);
            }

                const sortBy = this.$refs.table?.localSortBy || null;
                const sortDesc = this.$refs.table?.localSortDesc || false;

            if (sortBy) {
                params.append("sort_by", sortBy);
                params.append("sort_desc", sortDesc ? "true" : "false");
            }

            const response = await fetch(`/api-py/psd/download?${params.toString()}`);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            // Determine the year(s) for the filename
            let fromYearFormatted = 'все_года';
            let toYearFormatted = '';

            if (this.dateFromForInput) {
                fromYearFormatted = this.dateFromForInput.getFullYear().toString();
            }
            if (this.dateToForInput) {
                toYearFormatted = this.dateToForInput.getFullYear().toString();
            }

            // If no dates are selected, default to 'все_года'
            const filename = `Проектно_сметная_документация_${fromYearFormatted}_${toYearFormatted}.xls`;

            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Ошибка при загрузке Excel-файла:", error);
        }
    }

    private loading: boolean = false;

    async downloadInfo() {
        if (this.loading) {
            this.makeToast(
                "info",
                "Внимание",
                "Скоро начнется скачивание. Пожалуйста ожидайте."
            );
        } else {
            this.loading = true;
            await axios({
                method: "post",
                url: "/api-py/get-info/39",
                responseType: "blob",
                data: null,
            })
                .then((response) => response.data)
                .then((data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    const titleOfFile =
                        "Инструкция_Проектно_сметная_документация";
                    link.setAttribute("download", titleOfFile + ".pdf");
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    console.log(error);
                    this.makeToast(
                        "danger",
                        "Ошибка запроса руководства пользователя",
                        error.toString()
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }


    filterObjectOptions: any[] = [];
    filterProjectTimeOptions: any[] = [];
    filterObjectPlaceOptions: any[] = [];
    filterCustomerOptions: any[] = [];
    filterPlannerOptions: any[] = [];
    filterCategoryOptions: any[] = [];
    filterStatusOptions: any[] = [];

    initializeFilters() {
        this.filterObjectOptions = this.getUniqueValues(this.items, 'project');
        this.filterProjectTimeOptions = this.getUniqueValues(this.items, 'timelimit');
        this.filterObjectPlaceOptions = this.getUniqueValues(this.items, 'object_place');
        this.filterCustomerOptions = this.getUniqueValues(this.items, 'customer');
        this.filterPlannerOptions = this.getUniqueValues(this.items, 'planner');

        // Динамически сформированные поля в формате { value, text }
        const rawCategories = this.items.map(item => item.object_category).filter(Boolean);
        const rawStatuses = this.items.map(item => item.status).filter(Boolean);

        this.filterCategoryOptions = this.formatToValueText([...new Set(rawCategories)]);
        this.filterStatusOptions = this.formatToValueText([...new Set(rawStatuses)]);
    }

    formatToValueText(array: string[]): { value: string, text: string }[] {
        return array.map(val => ({
            value: val,
            text: val.charAt(0).toUpperCase() + val.slice(1)  // Сделаем красивый текст
        }));
    }


    @Watch('filterObjectName')
    @Watch('filterProjectTime')
    @Watch('filterObjectPlace')
    @Watch('filterCustomerBIN')
    @Watch('filterPlanner')
    @Watch('filterCategory')
    @Watch('filterStatus')  // Добавлен watch на статус
    onFilterChange() {
         this.loadFilterOptions()
    }

    updateFilters() {
    // Основная фильтрация для таблицы
    const filteredItems = this.items.filter(item =>
        (!this.filterObjectName || item.project === this.filterObjectName.project) &&
        (!this.filterProjectTime || item.timelimit === this.filterProjectTime.timelimit) &&
        (!this.filterObjectPlace || item.object_place === this.filterObjectPlace.object_place) &&
        (!this.filterCustomerBIN || item.customer === this.filterCustomerBIN.customer) &&
        (!this.filterPlanner || item.planner === this.filterPlanner.planner) &&
        (!this.filterCategory || item.object_category === this.filterCategory.value) &&
        (!this.filterStatus || item.status === this.filterStatus.value)
    );

    // Обновляем остальные опции (по аналогии)
    this.filterObjectOptions = this.getUniqueValues(
        this.items.filter(item =>
            (!this.filterProjectTime || item.timelimit === this.filterProjectTime.timelimit) &&
            (!this.filterObjectPlace || item.object_place === this.filterObjectPlace.object_place) &&
            (!this.filterCustomerBIN || item.customer === this.filterCustomerBIN.customer) &&
            (!this.filterPlanner || item.planner === this.filterPlanner.planner) &&
            (!this.filterCategory || item.object_category === this.filterCategory.value) &&
            (!this.filterStatus || item.status === this.filterStatus.value)
        ), 'project'
    );

    this.filterProjectTimeOptions = this.getUniqueValues(
        this.items.filter(item =>
            (!this.filterObjectName || item.project === this.filterObjectName.project) &&
            (!this.filterObjectPlace || item.object_place === this.filterObjectPlace.object_place) &&
            (!this.filterCustomerBIN || item.customer === this.filterCustomerBIN.customer) &&
            (!this.filterPlanner || item.planner === this.filterPlanner.planner) &&
            (!this.filterCategory || item.object_category === this.filterCategory.value) &&
            (!this.filterStatus || item.status === this.filterStatus.value)
        ), 'timelimit'
    );

    this.filterObjectPlaceOptions = this.getUniqueValues(
        this.items.filter(item =>
            (!this.filterObjectName || item.project === this.filterObjectName.project) &&
            (!this.filterProjectTime || item.timelimit === this.filterProjectTime.timelimit) &&
            (!this.filterCustomerBIN || item.customer === this.filterCustomerBIN.customer) &&
            (!this.filterPlanner || item.planner === this.filterPlanner.planner) &&
            (!this.filterCategory || item.object_category === this.filterCategory.value) &&
            (!this.filterStatus || item.status === this.filterStatus.value)
        ), 'object_place'
    );

    this.filterCustomerOptions = this.getUniqueValues(
        this.items.filter(item =>
            (!this.filterObjectName || item.project === this.filterObjectName.project) &&
            (!this.filterProjectTime || item.timelimit === this.filterProjectTime.timelimit) &&
            (!this.filterObjectPlace || item.object_place === this.filterObjectPlace.object_place) &&
            (!this.filterPlanner || item.planner === this.filterPlanner.planner) &&
            (!this.filterCategory || item.object_category === this.filterCategory.value) &&
            (!this.filterStatus || item.status === this.filterStatus.value)
        ), 'customer'
    );

    this.filterPlannerOptions = this.getUniqueValues(
        this.items.filter(item =>
            (!this.filterObjectName || item.project === this.filterObjectName.project) &&
            (!this.filterProjectTime || item.timelimit === this.filterProjectTime.timelimit) &&
            (!this.filterObjectPlace || item.object_place === this.filterObjectPlace.object_place) &&
            (!this.filterCustomerBIN || item.customer === this.filterCustomerBIN.customer) &&
            (!this.filterCategory || item.object_category === this.filterCategory.value) &&
            (!this.filterStatus || item.status === this.filterStatus.value)
        ), 'planner'
    );

    // --- Категория объекта ---
    const categoryFilteredItems = this.items.filter(item =>
        (!this.filterObjectName || item.project === this.filterObjectName.project) &&
        (!this.filterProjectTime || item.timelimit === this.filterProjectTime.timelimit) &&
        (!this.filterObjectPlace || item.object_place === this.filterObjectPlace.object_place) &&
        (!this.filterCustomerBIN || item.customer === this.filterCustomerBIN.customer) &&
        (!this.filterPlanner || item.planner === this.filterPlanner.planner) &&
        (!this.filterStatus || item.status === this.filterStatus.value)
    );

    const rawCategories = categoryFilteredItems
        .map(x => x.object_category)
        .filter(Boolean);

    const categorySet = new Set(rawCategories);

    if (this.filterCategory && this.filterCategory.value && !categorySet.has(this.filterCategory.value)) {
        categorySet.add(this.filterCategory.value);
    }

    this.filterCategoryOptions = this.formatToValueText([...categorySet]);

    // --- Статус ---
    const statusFilteredItems = this.items.filter(item =>
        (!this.filterObjectName || item.project === this.filterObjectName.project) &&
        (!this.filterProjectTime || item.timelimit === this.filterProjectTime.timelimit) &&
        (!this.filterObjectPlace || item.object_place === this.filterObjectPlace.object_place) &&
        (!this.filterCustomerBIN || item.customer === this.filterCustomerBIN.customer) &&
        (!this.filterPlanner || item.planner === this.filterPlanner.planner) &&
        (!this.filterCategory || item.object_category === this.filterCategory.value)
    );

    const rawStatuses = statusFilteredItems
        .map(x => x.status)
        .filter(Boolean);

    const statusSet = new Set(rawStatuses);

    if (this.filterStatus && this.filterStatus.value && !statusSet.has(this.filterStatus.value)) {
        statusSet.add(this.filterStatus.value);
    }

    this.filterStatusOptions = this.formatToValueText([...statusSet]);
}


    getFilteredValues(key: string) {
        return this.getUniqueValues(
            this.items.filter(item =>
                (!this.filterObjectName || item.project === this.filterObjectName.project) &&
                (!this.filterProjectTime || item.timelimit === this.filterProjectTime.timelimit) &&
                (!this.filterObjectPlace || item.object_place === this.filterObjectPlace.object_place) &&
                (!this.filterCustomerBIN || item.customer === this.filterCustomerBIN.customer) &&
                (!this.filterPlanner || item.planner === this.filterPlanner.planner)
            ),
            key
        );
    }

    obl: string = '';

    async getObl() {
     await fetch('/api-py/get-budget-obl/' + store.state._instanceCode)
                        .then(response => response.json())
                        .then(json => {
                            if (json.obl) this.obl = json.obl;
                        });
        console.log('code',  store.state._instanceCode)
        console.log('obl', this.obl)
    }

    codeList: { value: string; text: string }[] = [];

    async getCodeList() {
        try {

            const types = ['imported,development', 'current,other'];

            const allRequests = await Promise.all(
                types.map(type =>
                    fetch(`/api-py/get-project-bank-code-list/${type}/${this.obl}/${this.userUiid}`)
                )
            );

            const allData = await Promise.all(allRequests.map(res => res.json()));
            console.log('projects', allData)

            const combined = allData.flat().map((item: { code: string }) => ({
                value: item.code,
                text: item.code
            }));

            this.codeList = combined;
        } catch (error) {
            this.makeToast("danger", "Ошибка загрузки кодов проектов", error instanceof Error ? error.message : String(error));
        }
    }

    async refreshFromGoogleSheets() {
        try {
            const response = await fetch('/api-py/psd/testload');

            let errorText = '';
            let successHandled = false;

            if (response.ok) {
                const result = await response.json();
                this.makeToast("success", "Данные обновлены", `Загрузка прошла успешно`);
                await this.load_psd(); // или fetchData
                successHandled = true;
            } else {
                // пытаемся извлечь JSON-ошибку
                try {
                    const errorData = await response.json();
                    errorText = errorData.detail || JSON.stringify(errorData);
                } catch (jsonError) {
                    errorText = await response.text();
                }

                console.error("Ошибка загрузки:", response.status, errorText);
                this.makeToast("danger", `Ошибка загрузки (${response.status})`, errorText);
            }
        } catch (error) {
            this.makeToast("danger", "Ошибка обновления данных", error instanceof Error ? error.message : String(error));
        }
    }

    get userUiid() {
        return store.state.user.sub;
    }

    accessLevel: number = 0

    async getUserLevels() {
        if (this.userUiid) {
            let response: any = [];
            try {
                await loadUserLevels(this.userUiid).then(data => {
                    response = data;
                });
                for (const row of response) {
                    switch (row.modules) {
                        case "003.006":
                            this.accessLevel = row.access_level;
                            break;
                            default:
                                break;
                    }
                }
            } catch (error) {
                this.makeToast("danger", "Ошибка getUserLevels", error instanceof Error ? error.message : String(error));
            }
        }
    }

    get isItemDisabled() {
        const levelAccessToEdit = [2, 3];
        return !levelAccessToEdit.includes(this.accessLevel);
    }

    
    availableForUser = true;

    async created() {
        await this.getUserLevels();
        if (![1, 2, 3].includes(this.accessLevel)) {
            this.availableForUser = false
            this.makeToast('danger', 'Отсутствует доступ к режиму', 'Сообщение')
            return
        }
    }




}

